import { isAuthorMode } from '../../utils/aem-utils';
import { isMobile } from '../../utils/device-utils';

const LAZY_CLASSNAME_SELECTOR = 'img.j-lazyload, iframe[data-src]';

const processSrc = (element) => {
  const $element = element.target || element;
  if ($element.dataset?.lazyimgmobile && $element.dataset?.lazyimgdesktop) {
    $element.setAttribute('src', isMobile() ? $element.dataset.lazyimgmobile : $element.dataset.lazyimgdesktop);
  } else {
    if ($element.dataset?.src) {
      $element.setAttribute('src', $element.dataset.src);
    }
    if ($element.dataset?.srcset) {
      $element.setAttribute('srcset', $element.dataset.srcset);
    }
  }
};

const observerOptions = {
  root: null,
  rootMargin: '500px',
  threshold: 0.1,
};

const lazyObserverCallback = (entries, lazyObserver) => {
  entries.forEach((entry) => {
    if (isAuthorMode()) {
      processSrc(entry);
      lazyObserver.unobserve(entry.target);
    } else if (entry.isIntersecting) {
      processSrc(entry);
      lazyObserver.unobserve(entry.target);
    }
  });
};

/**
 * Initialize Content Lazy Loading
 */
const initLazyContentLoader = async () => {
  console.info('init lazy-content-loader');
  const lazyObserver = new IntersectionObserver(lazyObserverCallback, observerOptions);

  document.querySelectorAll(LAZY_CLASSNAME_SELECTOR).forEach(($lazyElement) => {
    lazyObserver.observe($lazyElement);
  });

  if (isAuthorMode()) {
    // In author mode, we need to watch for dynamically added images and iframes
    const $container = document.querySelector('body');
    const bodyObserver = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          node?.querySelectorAll?.(LAZY_CLASSNAME_SELECTOR)?.forEach(processSrc);
        });
      });
    });
    bodyObserver.observe($container, { childList: true, subtree: true });
  }
};

export { initLazyContentLoader };
